// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Widget tam olarak ekranın üstünde olacak şekilde sabitleniyor */
.search-settings {
    position: fixed; /* Ekranın ortasında sabitle */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0); /* Yavaşça büyütme */
    width: 90%;
    max-width: 800px;
    background-color: white;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    padding: 20px;
    opacity: 0;
    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
    z-index: 9999;
}

.search-settings.open {
    transform: translate(-50%, -50%) scale(1); /* Widget’ı büyüterek aç */
    opacity: 1;
}

.settings-container {
    padding: 20px;
}

.input-group {
    margin-bottom: 1.5rem;
}

.input-group label {
    font-size: 1rem;
    display: block;
    margin-bottom: 0.5rem;
}

.input-group select,
.input-group input,
.input-group textarea {
    width: 100%;
    padding: 8px;
    font-size: 1rem;
    border: 1px solid #3c4f58;
    border-radius: 8px;
}

.row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}

.row .input-group {
    flex: 1 1;
}

.full-width {
    width: 100%;
}

.actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;
}

.actions .btn-clear {
    background-color: transparent;
    color: #3c4f58;
    border: 1px solid #3c4f58;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 1rem;
}

.actions .btn-apply {
    background-color: #3c4f58;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
}
.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 2rem;
    color: #333;
    cursor: pointer;
}

.close-button:hover {
    color: #750000; /* Hover durumunda kırmızı renk */
}
.row {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}

.input-group {
    flex: 1 1;
}

.date-input-group {
    display: flex;
    gap: 1rem;
}

.date-input-group input {
    flex: 1 1;
}
.year-input-group {
    display: flex;
    gap: 1rem;
}

.year-input-group select {
    flex: 1 1;
    padding: 8px;
    border: 1px solid #3c4f58;
    border-radius: 8px;
    font-size: 1rem;
    background-color: white;
}

.year-input-group select:focus {
    outline: none;
    border-color: #003c4f;
    box-shadow: 0 0 0 2px rgba(0, 60, 79, 0.1);
}

/* Optional: Style for the option elements */
.year-input-group select option {
    padding: 8px;
    font-size: 1rem;
    margin-top: 10px;
}

.table-content-main-div {
    display: flex;                  
    justify-content: flex-start;    
    align-items: center;
    gap:1rem;                                      
}

.table-content-label-div {
    display: flex;              /* Flexbox düzeni aktif edilir */
    justify-content: center;    /* Yatayda ortalar (bu gerek olmayabilir, ancak eklenebilir) */
    align-items: center;        /* Dikeyde ortalar */
    font-size: 1rem;            
    padding: 0;                 
    margin: 0;                  
    border: none;              
    line-height: 1.5;
}   

.table-content-checkbox-div {
    display: flex;              /* Flexbox düzeni aktif edilir */
    justify-content: center;    /* Yatayda ortalar (bu gerek olmayabilir, ancak eklenebilir) */
    align-items: center;        /* Dikeyde ortalar */
    font-size: 1rem;            
    padding: 0;                 
    margin: 0;                  
    border: none;              
    line-height: 1.5;           /* Gerekirse satır yüksekliği ayarlanabilir */
}

.table-content-checkbox-div > input{
    transform: scale(1.5);
}

/*mode: "table" || mode:"text" gonderilecek olan sorgu*/`, "",{"version":3,"sources":["webpack://./src/components/SearchSettings/SearchSettings.css"],"names":[],"mappings":"AAAA,kEAAkE;AAClE;IACI,eAAe,EAAE,8BAA8B;IAC/C,QAAQ;IACR,SAAS;IACT,yCAAyC,EAAE,oBAAoB;IAC/D,UAAU;IACV,gBAAgB;IAChB,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gEAAgE;IAChE,aAAa;AACjB;;AAEA;IACI,yCAAyC,EAAE,0BAA0B;IACrE,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc,EAAE,iCAAiC;AACrD;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;AACX;AACA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA,4CAA4C;AAC5C;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa,eAAe,gCAAgC;IAC5D,uBAAuB,KAAK,8DAA8D;IAC1F,mBAAmB,SAAS,oBAAoB;IAChD,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa,eAAe,gCAAgC;IAC5D,uBAAuB,KAAK,8DAA8D;IAC1F,mBAAmB,SAAS,oBAAoB;IAChD,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;IACZ,gBAAgB,YAAY,6CAA6C;AAC7E;;AAEA;IACI,qBAAqB;AACzB;;AAEA,uDAAuD","sourcesContent":["/* Widget tam olarak ekranın üstünde olacak şekilde sabitleniyor */\r\n.search-settings {\r\n    position: fixed; /* Ekranın ortasında sabitle */\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%) scale(0); /* Yavaşça büyütme */\r\n    width: 90%;\r\n    max-width: 800px;\r\n    background-color: white;\r\n    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);\r\n    border-radius: 12px;\r\n    padding: 20px;\r\n    opacity: 0;\r\n    transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;\r\n    z-index: 9999;\r\n}\r\n\r\n.search-settings.open {\r\n    transform: translate(-50%, -50%) scale(1); /* Widget’ı büyüterek aç */\r\n    opacity: 1;\r\n}\r\n\r\n.settings-container {\r\n    padding: 20px;\r\n}\r\n\r\n.input-group {\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.input-group label {\r\n    font-size: 1rem;\r\n    display: block;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.input-group select,\r\n.input-group input,\r\n.input-group textarea {\r\n    width: 100%;\r\n    padding: 8px;\r\n    font-size: 1rem;\r\n    border: 1px solid #3c4f58;\r\n    border-radius: 8px;\r\n}\r\n\r\n.row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n}\r\n\r\n.row .input-group {\r\n    flex: 1;\r\n}\r\n\r\n.full-width {\r\n    width: 100%;\r\n}\r\n\r\n.actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.actions .btn-clear {\r\n    background-color: transparent;\r\n    color: #3c4f58;\r\n    border: 1px solid #3c4f58;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.actions .btn-apply {\r\n    background-color: #3c4f58;\r\n    color: white;\r\n    padding: 0.5rem 1rem;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n.close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: none;\r\n    border: none;\r\n    font-size: 2rem;\r\n    color: #333;\r\n    cursor: pointer;\r\n}\r\n\r\n.close-button:hover {\r\n    color: #750000; /* Hover durumunda kırmızı renk */\r\n}\r\n.row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: 1rem;\r\n}\r\n\r\n.input-group {\r\n    flex: 1;\r\n}\r\n\r\n.date-input-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n}\r\n\r\n.date-input-group input {\r\n    flex: 1;\r\n}\r\n.year-input-group {\r\n    display: flex;\r\n    gap: 1rem;\r\n}\r\n\r\n.year-input-group select {\r\n    flex: 1;\r\n    padding: 8px;\r\n    border: 1px solid #3c4f58;\r\n    border-radius: 8px;\r\n    font-size: 1rem;\r\n    background-color: white;\r\n}\r\n\r\n.year-input-group select:focus {\r\n    outline: none;\r\n    border-color: #003c4f;\r\n    box-shadow: 0 0 0 2px rgba(0, 60, 79, 0.1);\r\n}\r\n\r\n/* Optional: Style for the option elements */\r\n.year-input-group select option {\r\n    padding: 8px;\r\n    font-size: 1rem;\r\n    margin-top: 10px;\r\n}\r\n\r\n.table-content-main-div {\r\n    display: flex;                  \r\n    justify-content: flex-start;    \r\n    align-items: center;\r\n    gap:1rem;                                      \r\n}\r\n\r\n.table-content-label-div {\r\n    display: flex;              /* Flexbox düzeni aktif edilir */\r\n    justify-content: center;    /* Yatayda ortalar (bu gerek olmayabilir, ancak eklenebilir) */\r\n    align-items: center;        /* Dikeyde ortalar */\r\n    font-size: 1rem;            \r\n    padding: 0;                 \r\n    margin: 0;                  \r\n    border: none;              \r\n    line-height: 1.5;\r\n}   \r\n\r\n.table-content-checkbox-div {\r\n    display: flex;              /* Flexbox düzeni aktif edilir */\r\n    justify-content: center;    /* Yatayda ortalar (bu gerek olmayabilir, ancak eklenebilir) */\r\n    align-items: center;        /* Dikeyde ortalar */\r\n    font-size: 1rem;            \r\n    padding: 0;                 \r\n    margin: 0;                  \r\n    border: none;              \r\n    line-height: 1.5;           /* Gerekirse satır yüksekliği ayarlanabilir */\r\n}\r\n\r\n.table-content-checkbox-div > input{\r\n    transform: scale(1.5);\r\n}\r\n\r\n/*mode: \"table\" || mode:\"text\" gonderilecek olan sorgu*/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
